<nav>
  @if (site=='tp') {
  <div class="nav-bar blue-sidenav">
    @if (showDashboard) {
    <button
      [routerLink]="currentLang == 'fr' ? '/fr/training-provider/my-training-programs' : '/training-provider/my-training-programs'"
      [class.selected]="dashboardSelected"
      [matTooltip]="'ApplicationForNewTrainingProgram.MyTrainingPrograms' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'ApplicationForNewTrainingProgram.MyTrainingPrograms' | translate"
        [src]="dashboardSelected ? 'assets/images/nav-prog-delivery-white.svg' : 'assets/images/nav-prog-delivery.svg'" />
      @if (contextMenu) {
      <span>{{'ApplicationForNewTrainingProgram.MyTrainingPrograms' | translate}}</span>
      }
    </button>
    }
    @if (showSchedule) {
    <button
      [routerLink]="currentLang == 'fr' ? '/fr/training-provider/training-schedules' : '/training-provider/training-schedules'"
      [class.selected]="scheduleSelected" [matTooltip]="'TrainingSchedules.MyTrainingSchedules' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'TrainingSchedules.MyTrainingSchedules' | translate"
        [src]="scheduleSelected ? 'assets/images/nav-calendar-white.svg' : 'assets/images/nav-calendar.svg'" />
      @if (contextMenu) {
      <span>{{'TrainingSchedules.MyTrainingSchedules' | translate}}</span>
      }
    </button>
    }
    @if (showLearners) {
    <button [routerLink]="currentLang == 'fr' ? '/fr/training-provider/teams' : '/training-provider/teams'"
      [class.selected]="teamsSelected" [matTooltip]="'Teams.Title' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'Teams.Title' | translate"
        [src]="teamsSelected ? 'assets/images/my-team-white.svg' : 'assets/images/my-team.svg'" />
      @if (contextMenu) {
      <span>{{'Teams.Title' | translate}}</span>
      }
    </button>
    }
    @if (showNotifications) {
    <button
      [routerLink]="currentLang == 'fr' ? '/fr/training-provider/my-notifications' : '/training-provider/my-notifications'"
      [class.selected]="notificationsSelected"
      [matBadge]="hasUnreadNotifications ? userService.unreadNotificationCount : null"
      [matBadgeHidden]="!hasUnreadNotifications" [matTooltip]="'MyNotifications.Title' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'MyNotifications.Title' | translate"
        [src]="notificationsSelected?'assets/images/notifications-white.svg':'assets/images/notifications.svg'" />
      @if (contextMenu) {
      <span>{{'MyNotifications.Title' | translate}}</span>
      }
    </button>
    }
    @if (showTeams) {
    <button [routerLink]="currentLang == 'fr' ? '/fr/training-provider/my-learners' : '/training-provider/my-learners'"
      [class.selected]="learnersSelected" [matTooltip]="'MyLearners.Title' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'MyLearners.Title' | translate"
        [src]="learnersSelected? 'assets/images/my-learners-white.svg' : 'assets/images/my-learners.svg'" />
      @if (contextMenu) {
      <span>{{'MyLearners.Title' | translate}}</span>
      }
    </button>
    }
    @if (showReporting) {
    <button [routerLink]="currentLang == 'fr' ? '/fr/training-provider/reporting' : '/training-provider/reporting'"
      [class.selected]="reportingSelected" [matTooltip]="'Tab.Reports' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img class="report" [alt]="'Tab.Reports' | translate"
        [src]="reportingSelected ? 'assets/images/report.svg' : 'assets/images/report-white.svg'" />
      @if (contextMenu) {
      <span>{{'Tab.Reports' | translate}}</span>
      }
    </button>
    }
    <button [routerLink]="currentLang == 'fr' ? '/fr/training-provider/contact-us' : '/training-provider/contact-us'"
      [class.selected]="contactUsSelected" [matTooltip]="'TrainingProviderContactUs.ContactUs' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'TrainingProviderContactUs.ContactUs' | translate"
        [src]="contactUsSelected ? 'assets/images/nav-support-white.svg' : 'assets/images/nav-support.svg'" />
      @if (contextMenu) {
      <span>{{'TrainingProviderContactUs.ContactUs' | translate}}</span>
      }
    </button>
    <button [routerLink]="currentLang == 'fr' ? '/fr/training-provider/faqs' : '/training-provider/faqs'"
      [class.selected]="faqSelected" [matTooltip]="'General.FAQ' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'General.FAQ' | translate"
        [src]="faqSelected ? 'assets/images/nav-knowledge-white.svg' : 'assets/images/nav-knowledge.svg'" />
      @if (contextMenu) {
      <span>{{'General.FAQ' | translate}}</span>
      }
    </button>
    @if (showAccountSettings) {
    <button
      [routerLink]="currentLang == 'fr' ? '/fr/training-provider/account-settings' : '/training-provider/account-settings'"
      [class.selected]="accSettingsSelected" [matTooltip]="'Tab.AccountSettings' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img class="account-settings" [alt]="'Tab.AccountSettings' | translate"
        [src]="accSettingsSelected ? 'assets/images/gear.svg' : 'assets/images/gear-white.svg'" />
      @if (contextMenu) {
      <span>{{'Tab.AccountSettings' | translate}}</span>
      }
    </button>
    }
  </div>
  }
</nav>
<nav>
  @if (site=='learner') {
  <div class="nav-bar">
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/certifications' : '/worker/certifications')"
      [class.selected]="isCertificationSelected" [matTooltip]="'Worker.Certifications' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'Worker.Certifications' | translate"
        [src]="isCertificationSelected ? 'assets/images/nav-certificate-white.svg' : 'assets/images/nav-certificate.svg'" />
      @if (contextMenu) {
      <span>{{'Worker.Certifications' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/profile-review' : '/worker/profile-review')"
      [class.selected]="isProfileSelected" [matTooltip]="'Worker.Profile' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'Worker.Profile' | translate"
        [src]="isProfileSelected ? 'assets/images/nav-user-profile-white.svg' : 'assets/images/nav-user-profile.svg'" />
      @if (contextMenu) {
      <span>{{'Worker.Profile' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/training-schedules' : '/worker/training-schedules')"
      [class.selected]="isScheduleSelected" [matTooltip]="'Worker.MyTrainingSchedules' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'Worker.MyTrainingSchedules' | translate"
        [src]="isScheduleSelected ? 'assets/images/nav-calendar-white.svg' : 'assets/images/nav-calendar.svg'" />
      @if (contextMenu) {
      <span>{{'Worker.MyTrainingSchedules' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/notifications' : '/worker/notifications')"
      [class.selected]="isNotificationsSelected" [matTooltip]="'MyNotifications.Title' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'MyNotifications.Title' | translate"
        [src]="isNotificationsSelected ? 'assets/images/notifications-white.svg' : 'assets/images/notifications.svg'" />
      @if (contextMenu) {
      <span>{{'MyNotifications.Title' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/contact-us' : '/worker/contact-us')"
      [class.selected]="isContactUsSelected" [matTooltip]="'Worker.ContactUs' | translate" matTooltipPosition="right"
      matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'Worker.ContactUs' | translate"
        [src]="isContactUsSelected ? 'assets/images/nav-support-white.svg' : 'assets/images/nav-support.svg'" />
      @if (contextMenu) {
      <span>{{'Worker.ContactUs' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang == 'fr' ? '/fr/worker/faq' : '/worker/faq')" [class.selected]="isFaqSelected"
      [matTooltip]="'General.FAQ' | translate" matTooltipPosition="right" matTooltipShowDelay="500"
      [matTooltipDisabled]="contextMenu">
      <img [alt]="'General.FAQ' | translate"
        [src]="isFaqSelected ? 'assets/images/nav-knowledge-white.svg' : 'assets/images/nav-knowledge.svg'" />
      @if (contextMenu) {
      <span>{{'General.FAQ' | translate}}</span>
      }
    </button>
  </div>
  }
  @if (site=='employer') {
  <div class="nav-bar">
    <button (click)="goTo(currentLang == 'fr' ? '/fr/employer/my-worker-records' : '/employer/my-worker-records')"
      [class.selected]="isWorkerRecordsSelected" [matTooltip]="'EmployerPortal.MyWorkerRecords' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'EmployerPortal.MyWorkerRecords' | translate"
        [src]="isWorkerRecordsSelected ? 'assets/images/nav-user-profile-white.svg' : 'assets/images/nav-user-profile.svg'" />
      @if (contextMenu) {
      <span>{{'EmployerPortal.MyWorkerRecords' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang === 'fr' ? '/fr/employer/my-teams' : '/employer/my-teams')"
      [class.selected]="currentlySelectedEmployerRouteName === 'myTeams'"
      [matTooltip]="'EmployerPortal.MyTeam' | translate" matTooltipPosition="right" matTooltipShowDelay="500"
      [matTooltipDisabled]="contextMenu">
      <img [alt]="'EmployerPortal.MyTeam' | translate"
        [src]="currentlySelectedEmployerRouteName === 'myTeams' ? 'assets/images/my-team-white.svg' : 'assets/images/my-team.svg'" />
      @if (contextMenu) {
      <span>{{'EmployerPortal.MyTeam' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang === 'fr' ? '/fr/employer/sose-program' : '/employer/sose-program')"
      [class.selected]="isSoseSelected" [matTooltip]="'EmployerPortal.SoseProgram' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'EmployerPortal.SoseProgram' | translate"
        [src]="isSoseSelected ? 'assets/images/nav-sose-white.svg' : 'assets/images/nav-sose.svg'" class="sose-icon" />
      @if (contextMenu) {
      <span>{{'EmployerPortal.SoseProgram' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang === 'fr' ? '/fr/employer/faq' : '/employer/faq')"
      [class.selected]="currentlySelectedEmployerRouteName === 'faq'" [matTooltip]="'General.FAQ' | translate"
      matTooltipPosition="right" matTooltipShowDelay="500" [matTooltipDisabled]="contextMenu">
      <img [alt]="'General.FAQ' | translate"
        [src]="currentlySelectedEmployerRouteName === 'faq' ? 'assets/images/nav-knowledge-white.svg' : 'assets/images/nav-knowledge.svg'" />
      @if (contextMenu) {
      <span>{{'General.FAQ' | translate}}</span>
      }
    </button>
    <button (click)="goTo(currentLang === 'fr' ? '/fr/employer/contact-us' : '/employer/contact-us')"
      [class.selected]="currentlySelectedEmployerRouteName === 'contactUs'"
      [matTooltip]="'EmployerPortal.ContactUs' | translate" matTooltipPosition="right" matTooltipShowDelay="500"
      [matTooltipDisabled]="contextMenu">
      <img [alt]="'EmployerPortal.ContactUs' | translate"
        [src]="currentlySelectedEmployerRouteName === 'contactUs' ? 'assets/images/nav-support-white.svg' : 'assets/images/nav-support.svg'" />
      @if (contextMenu) {
      <span>{{'EmployerPortal.ContactUs' | translate}}</span>
      }
    </button>
  </div>
  }
</nav>